import type { EmployeeAlertFirstJobHistoryStartDateNotSameAsHiredDate } from '@/common/graphql';

import { FormattedDate } from '../FormattedDate';

export const DetailDescriptionEmployeeAlertFirstJobHistoryStartDateNotSameAsHiredDate = ({
  reason,
}: {
  reason: Pick<EmployeeAlertFirstJobHistoryStartDateNotSameAsHiredDate, 'hiredDate' | 'firstStartDate'>;
}) => (
  <>
    <div>
      <FormattedDate prefix="Hired date" date={reason.hiredDate} />
    </div>
    <div>
      <FormattedDate prefix="First job history start date" date={reason.firstStartDate} />
    </div>
  </>
);
